"use client";

import { useEffect, useState } from "react";
import type { Item } from "@/lib/cases";
import { fmt } from "@/lib/money";
import { itemAlt } from "@/lib/seo";

export type DropView = Item & { id: number; value: number; name: string };

/** One drop: skin on its rarity floor, value, who got it. */
export function DropTile({ d }: { d: DropView }) {
  const [weapon, skin] = d.n.split(" | ");
  return (
    <div className="drop-tile rarity-tile" style={{ "--rc": d.r } as React.CSSProperties} title={`${d.name} · ${d.n}${d.w ? ` (${d.w})` : ""}`}>
      <img src={d.i} alt={itemAlt(d)} loading="lazy" />
      <span className="truncate text-[11px] font-semibold text-muted">{skin ? weapon : ""}</span>
      <span className="truncate text-[12px] font-bold">{skin ?? weapon}</span>
      <span className="coin text-[12px] text-money">{fmt(d.value)}</span>
      <span className="truncate text-[11px] text-dim">{d.name}</span>
    </div>
  );
}

/** Recent drops from one case, polled every 6 s; new tiles slide in. */
export default function CaseDrops({ slug, initial, empty }: { slug: string; initial: DropView[]; empty: string }) {
  const [drops, setDrops] = useState(initial);
  const [seen] = useState(() => new Set(initial.map((d) => d.id)));
  useEffect(() => {
    const tick = async () => {
      if (document.hidden) return;
      try { setDrops(await (await fetch(`/case/${slug}/drops`, { cache: "no-store" })).json()); } catch {}
    };
    const id = setInterval(tick, 6000);
    return () => clearInterval(id);
  }, [slug]);

  if (!drops.length) return <p className="empty-note">{empty}</p>;
  return (
    <div className="drop-row">
      {drops.map((d) => <div key={d.id} className={seen.has(d.id) ? "" : "drop-in"}><DropTile d={d} /></div>)}
    </div>
  );
}

